import { useCallback } from 'react';
import { toast } from 'react-toastify';
import { useAuth } from '../context/authContext';
import useHttp from './useHttp';

const useOldBookingImport = () => {
  const auth = useAuth();
  const { isLoading, error, sendRequest } = useHttp();

  const startImport = useCallback(
    async payload => {
      try {
        return await sendRequest({
          url: '/api/v1/oldBookingImport/import',
          method: 'POST',
          headers: auth.getAuthHeaders(),
          body: payload,
        });
      } catch (err) {
        toast.error('Fehler beim Starten des Old-Bookings-Imports');
        throw err;
      }
    },
    [auth, sendRequest]
  );

  const getImportJob = useCallback(
    async jobId => {
      try {
        return await sendRequest({
          url: `/api/v1/oldBookingImport/job/${jobId}`,
          method: 'GET',
          headers: auth.getAuthHeaders(),
        });
      } catch (err) {
        toast.error('Fehler beim Laden des Importstatus');
        throw err;
      }
    },
    [auth, sendRequest]
  );

  const getLatestImportJob = useCallback(
    async branchId => {
      try {
        const query = branchId ? `?branchId=${encodeURIComponent(branchId)}` : '';
        return await sendRequest({
          url: `/api/v1/oldBookingImport/job/latest${query}`,
          method: 'GET',
          headers: auth.getAuthHeaders(),
        });
      } catch (err) {
        toast.error('Fehler beim Laden des letzten Importstatus');
        throw err;
      }
    },
    [auth, sendRequest]
  );

  return { isLoading, error, startImport, getImportJob, getLatestImportJob };
};

export default useOldBookingImport;
